/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".value-box[_ngcontent-%COMP%]   .edit-icon[_ngcontent-%COMP%]{visibility:hidden}.value-box[_ngcontent-%COMP%]:hover{cursor:pointer}.value-box[_ngcontent-%COMP%]:hover   .edit-icon[_ngcontent-%COMP%]{visibility:initial}.custom-limit-set[_ngcontent-%COMP%]{color:#4aaed9}"];
export { styles as styles };

